"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModalButtons = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _env = _interopRequireDefault(require("../../utils/env/env"));
var _Close24PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/Close24PxOutlined"));
var _noScroll = require("../../utils/scroll/noScroll");
var _ChevronLeft24PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/ChevronLeft24PxOutlined"));
var _Button = require("../../elements/button/Button");
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _modalModule = _interopRequireDefault(require("./modal.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // jl-ui-kit
var logWarning = function logWarning(message) {
  if (_env["default"].isClientNonProd) {
    // eslint-disable-next-line no-console
    console.warn("%cJL-UI-KIT: Warning\n  Modal: ".concat(message), 'color: red;');
  }
};
var Modal = /*#__PURE__*/function (_Component) {
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _callSuper(this, Modal, [props]);
    _defineProperty(_this, "onCloseClick", function () {
      _this.closeModal();
    });
    _defineProperty(_this, "onReactModalRequestClose", function () {
      _this.closeModal();
    });
    _defineProperty(_this, "onReactModalAfterOpen", function () {
      (0, _noScroll.setNoScroll)(true);
    });
    _defineProperty(_this, "onBackClick", function () {
      var _this$props = _this.props,
        disableControls = _this$props.disableControls,
        onBack = _this$props.onBack;
      if (!disableControls) {
        _this.keepFocusWithinModal();
        onBack();
      }
    });
    _defineProperty(_this, "keepFocusWithinModal", function () {
      var content = _this.contentRef;
      if (content && content.focus) {
        content.focus();
      }
    });
    if (_env["default"].isClient) {
      var rootId = 'page-root';
      if (document.getElementById(rootId) && document.getElementById(rootId) !== document.body) {
        _reactModal["default"].setAppElement("#".concat(rootId));
      }
      document.documentElement.setAttribute('data-modal', 'false');
    }
    _this.state = {
      isOpen: _this.props.isOpen
    };
    return _this;
  }

  // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/231
  _inherits(Modal, _Component);
  return _createClass(Modal, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;
      if (prevProps.isOpen && !isOpen) {
        (0, _noScroll.setNoScroll)(false);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var rootId = 'page-root';
      var downgradePageRootIdError = this.props.downgradePageRootIdError;
      if (document.getElementById(rootId) && document.getElementById(rootId) !== document.body) {
        _reactModal["default"].setAppElement("#".concat(rootId));
      } else if (downgradePageRootIdError) {
        console.error('JLDS_ERROR_01: Missing page-root ID: The main container for the page level application is missing the required id="page-root" attribute: For more info please visit => https://prod-jl-design-system-storybook.design-system.prod.jl-digital.net/?path=/docs/errors-jlds-error-01--docs');
      } else {
        throw new Error('JLDS_ERROR_01: Missing page-root ID: The main container for the page level application is missing the required id="page-root" attribute: For more info please visit => https://prod-jl-design-system-storybook.design-system.prod.jl-digital.net/?path=/docs/errors-jlds-error-01--docs');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _noScroll.setNoScroll)(false);
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      var _this$props2 = this.props,
        disableControls = _this$props2.disableControls,
        onClose = _this$props2.onClose;
      var isOpen = this.state.isOpen;
      if (isOpen && !disableControls) {
        this.setState({
          isOpen: false
        });
        (0, _noScroll.setNoScroll)(false);
        onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        className = _this$props3.className,
        children = _this$props3.children,
        header = _this$props3.header,
        headerButtonAction = _this$props3.headerButtonAction,
        headerButtonText = _this$props3.headerButtonText,
        headerChildren = _this$props3.headerChildren,
        headerCount = _this$props3.headerCount,
        fullscreen = _this$props3.fullscreen,
        a11yHeader = _this$props3.a11yHeader,
        forceFullHeight = _this$props3.forceFullHeight,
        closeButtonText = _this$props3.closeButtonText,
        backButtonText = _this$props3.backButtonText,
        hideCloseButton = _this$props3.hideCloseButton,
        shouldCloseOnOverlayClick = _this$props3.shouldCloseOnOverlayClick,
        shouldCloseOnEsc = _this$props3.shouldCloseOnEsc,
        showBackButton = _this$props3.showBackButton,
        large = _this$props3.large,
        headerStyleModifier = _this$props3.headerStyleModifier,
        scrollId = _this$props3.scrollId,
        disableControls = _this$props3.disableControls,
        hasPadding = _this$props3.hasPadding,
        headerTitleClassName = _this$props3.headerTitleClassName,
        headerButtonClassName = _this$props3.headerButtonClassName,
        headerChildrenClassName = _this$props3.headerChildrenClassName,
        closeButtonClassName = _this$props3.closeButtonClassName,
        modalChildrenClassName = _this$props3.modalChildrenClassName;
      var isOpen = this.state.isOpen;

      /*
        From: http://reactcommunity.org/react-modal/accessibility/#aria
        You should use the contentLabel prop to provide a label for the modal
        content (via aria-label) if there is no visible label on the screen.
        If the modal is already labeled with visible text, you should specify
        the element including the label with the aria-labelledby attribute
        using the aria prop
      */
      var contentLabel;
      var aria;
      if (a11yHeader && a11yHeader !== header) {
        contentLabel = a11yHeader;
      } else if (header) {
        aria = {
          labelledby: 'modal-header'
        };
      } else {
        logWarning('you need to supply a "header" or "a11yHeader" prop');
      }

      // TODO: A11y: icons have no titles, review and revisit.

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactModal["default"], {
        isOpen: isOpen,
        contentLabel: contentLabel,
        aria: aria,
        onRequestClose: this.onReactModalRequestClose,
        onAfterOpen: this.onReactModalAfterOpen,
        className: {
          base: (0, _classnames["default"])(className, _modalModule["default"].modal, _defineProperty(_defineProperty(_defineProperty({}, _modalModule["default"].large, large && !fullscreen), _modalModule["default"].fullscreen, fullscreen), _modalModule["default"].forceFullHeight, forceFullHeight)),
          afterOpen: _modalModule["default"].modalAfterOpen,
          beforeClose: _modalModule["default"].modalBeforeClose
        },
        overlayClassName: {
          base: _modalModule["default"].overlay,
          afterOpen: _modalModule["default"].overlayAfterOpen,
          beforeClose: _modalModule["default"].overlayBeforeClose
        },
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEsc: shouldCloseOnEsc,
        ariaHideApp: true,
        role: "dialog",
        contentRef: function contentRef(node) {
          _this2.contentRef = node;
        },
        children: [(header || showBackButton) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
          className: (0, _classnames["default"])(_modalModule["default"].header, headerStyleModifier, _defineProperty({}, _modalModule["default"].fullWidthHeaderText, hideCloseButton && !showBackButton)),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
            className: (0, _classnames["default"])(_modalModule["default"].headerTitle, headerTitleClassName),
            id: "modal-header",
            children: [header, typeof headerCount !== 'undefined' && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: (0, _classnames["default"])(_modalModule["default"].headerCount),
              children: headerCount
            }), headerButtonText && headerButtonAction && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
              className: (0, _classnames["default"])(_modalModule["default"].headerButton, headerButtonClassName),
              small: true,
              onClick: headerButtonAction,
              "data-test": "modal-button-header",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: (0, _classnames["default"])(_modalModule["default"].headerButtonText),
                children: headerButtonText
              })
            })]
          }), headerChildren && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _classnames["default"])(_modalModule["default"].headerChildren, headerChildrenClassName),
            children: headerChildren
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "aria-live": "polite",
          "data-scroll-container": scrollId,
          className: _modalModule["default"].content,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            "data-test": "modal-children",
            "data-scroll-content": scrollId,
            className: (0, _classnames["default"])(_modalModule["default"].children, modalChildrenClassName, _defineProperty(_defineProperty({}, _modalModule["default"].noHeaderCloseButton, !header && !hideCloseButton && !showBackButton), _modalModule["default"]['children--has-padding'], hasPadding)),
            children: children
          })
        }), showBackButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          disabled: disableControls,
          className: (0, _classnames["default"])(_modalModule["default"].backButton, _modalModule["default"].button),
          onClick: this.onBackClick,
          "data-test": "modal-button-back",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronLeft24PxOutlined["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _modalModule["default"].buttonText,
            children: backButtonText
          })]
        }), !hideCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          disabled: disableControls,
          className: (0, _classnames["default"])(_modalModule["default"].button, _modalModule["default"].closeButton, closeButtonClassName),
          onClick: this.onCloseClick,
          "data-test": "modal-button-close",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Close24PxOutlined["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _modalModule["default"].buttonText,
            children: closeButtonText
          })]
        })]
      });
    }
  }]);
}(_react.Component); // TODO: Technical debt, component only used in documentation?
_defineProperty(Modal, "propTypes", {
  /** The content to render inside modal */
  children: _propTypes["default"].node.isRequired,
  /** Optional root class name */
  className: _propTypes["default"].string,
  /** show || hide modal */
  isOpen: _propTypes["default"].bool,
  /** creates a fixed header area at top of modal with your text centered vertically and horizontally */
  header: _staticContentPropCheck["default"],
  /** adds a number in brackets next to the header text */
  headerCount: _propTypes["default"].number,
  /** adds button text string alongside the header */
  headerButtonText: _propTypes["default"].string,
  /** the function to be invoked by the button */
  headerButtonAction: _propTypes["default"].func,
  /** The content to render addition1ally inside header */
  headerChildren: _propTypes["default"].node,
  /** a `class` modifier to override default header styles */
  headerStyleModifier: _propTypes["default"].string,
  /** the text you want voiceover to read out to describe the modal */
  a11yHeader: _staticContentPropCheck["default"],
  /** makes the modal fullscreen */
  fullscreen: _propTypes["default"].bool,
  /** forces modal to occupy full height on smaller screens (1) */
  forceFullHeight: _propTypes["default"].bool,
  /** disables modal closing when set */
  disableControls: _propTypes["default"].bool,
  /** hide the close button */
  hideCloseButton: _propTypes["default"].bool,
  /** close button is just an X icon, this text is used for a11y */
  closeButtonText: _staticContentPropCheck["default"],
  /** back button is just an < icon, this text is used for a11y */
  backButtonText: _staticContentPropCheck["default"],
  /** disable || enable modal closing when overlay background is clicked */
  shouldCloseOnOverlayClick: _propTypes["default"].bool,
  /** disable || enable modal closing when ESC key is clicked */
  shouldCloseOnEsc: _propTypes["default"].bool,
  /** show || hide back button */
  showBackButton: _propTypes["default"].bool,
  /** add data-scroll attributes to the modal content divs to assist use with scrollTo utility */
  scrollId: _propTypes["default"].string,
  /** callback for when close button is clicked */
  onClose: _propTypes["default"].func,
  /** callback for when back button is clicked */
  onBack: _propTypes["default"].func,
  /** increase the max width of the modal */
  large: _propTypes["default"].bool,
  /** add standard padding around modal children */
  hasPadding: _propTypes["default"].bool,
  /** a `class` modifier to override default header title styles */
  headerTitleClassName: _propTypes["default"].string,
  /** a `class` modifier to override default header button styles */
  headerButtonClassName: _propTypes["default"].string,
  /** a `class` modifier to override default header children styles */
  headerChildrenClassName: _propTypes["default"].string,
  /** a `class` modifier to override default close button styles */
  closeButtonClassName: _propTypes["default"].string,
  /** a `class` modifier to override default children styles */
  modalChildrenClassName: _propTypes["default"].string,
  downgradePageRootIdError: _propTypes["default"].bool
});
_defineProperty(Modal, "defaultProps", {
  className: undefined,
  isOpen: false,
  header: undefined,
  headerCount: undefined,
  headerButtonText: undefined,
  headerButtonAction: undefined,
  headerChildren: undefined,
  headerStyleModifier: undefined,
  a11yHeader: undefined,
  fullscreen: false,
  forceFullHeight: false,
  disableControls: false,
  hideCloseButton: false,
  closeButtonText: 'Close',
  backButtonText: 'Back',
  scrollId: undefined,
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEsc: true,
  showBackButton: false,
  onClose: function onClose() {
    return logWarning('no-op default implementation of props.onClose() has been called');
  },
  onBack: function onBack() {
    return logWarning('no-op default implementation of props.onBack() has been called');
  },
  large: false,
  hasPadding: true,
  headerTitleClassName: undefined,
  headerButtonClassName: undefined,
  headerChildrenClassName: undefined,
  closeButtonClassName: undefined,
  modalChildrenClassName: undefined,
  downgradePageRootIdError: false
});
var ModalButtons = exports.ModalButtons = function ModalButtons(_ref) {
  var inline = _ref.inline,
    children = _ref.children;
  if (children) {
    children.forEach(function (child) {
      if (child.props.inline) {
        logWarning('ModalButtons has "inline" prop which you should use instead of applying it to the Buttons.');
      }
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(_modalModule["default"].actions, _defineProperty({}, _modalModule["default"]['actions--inline'], inline)),
    children: children
  });
};
var _default = exports["default"] = Modal;